<template>
  <footer class="jw-footer">
    <Panel>
      <div class="flex" slot="panel">
        <div class="flex-item">
          <img class="logo" src="@/assets/img/logo-off.png" alt="">
          <span class="font-16 copyright-info weight-bold">Copyright © JWI Software Ltd.| 4000993800 <a href="http://www.beian.miit.gov.cn/" class="icp-text">粤ICP备07007137号</a></span>
        </div>

        <div class="wechat">
          <img @click="jumpLink('wechat')" src="@/assets/img/wechat.png" alt="">
          <img @click="jumpLink('in')" src="@/assets/img/in.png" class="margin-left-15" width="48" alt="">
        </div>
      </div>
    </Panel>
  </footer>
</template>

<script>
import Panel from '@/components/panel'
export default {
  components: {
    Panel
  },

  methods: {
    jumpLink (type) {
      if (type === 'in') {
        window.open('https://www.linkedin.com/company/3519789/')
      } else {
        window.open('https://mp.weixin.qq.com/s/kfaiJ3F_hUTJYKmKurIbvA')
      }
    }
  }
}

</script>

<style scoped>
  .jw-footer {
    height: 94px;
    line-height: 94px;
    background: #4D4A4A;
    color: #BDBEBB;
  }

  .logo {
    margin-right: 55px;
  }

  .wechat img {
    cursor: pointer;
  }

  .copyright-info {
    display: inline-block;
    position: relative;
    bottom: -17px;
  }

  .icp-text {
    color: #BDBEBB;
  }

  @media (max-width: 578px) {
    .jw-footer {
      height: 50px;
      line-height: 50px;
    }
    .copyright-info {
      display: none;
    }
    .logo,
    .wechat img {
      height: 30px;
    }
  }
</style>
